/**
 * clientGraph.js
 * 
 * API for handling getting client demographics data
 */

import axiosInstance from "./axios-instance";


/**
 * GET request to return client gender data
 * @param {*} query team to filter by
 * @returns Client gender data in format needed for Chartjs
 */
const clientGender = function (query) {
    return axiosInstance.get(`/clients/gender/graph${query}`).then(res => res);
}


/**
 * GET request to return client goals data
 * @param {*} query team to filter by
 * @returns Client goal data in format needed for Chartjs
 */
const clientGoals = function (goalType, query) {
    return axiosInstance.get(`/clients/goals/${goalType}/graph${query}`).then(res => res);
}


/**
 * GET request to return client age data
 * @param {*} query team to filter by
 * @returns Client age data in format needed for Chartjs
 */
const clientAge = function (query) {
    return axiosInstance.get(`/clients/age/graph${query}`).then(res => res);
}


/**
 * GET request to return client referral data
 * @param {*} query team to filter by
 * @returns Client referral data in format needed for Chartjs
 */
const clientReferral = function (query) {
    return axiosInstance.get(`/clients/referral/graph${query}`).then(res => res);
}

/**
 * GET request to return client discharge data
 * @param {*} query team to filter by
 * @returns Client discharge data in format needed for Chartjs
 */
const clientDischarge = function (query) {
    return axiosInstance.get(`/clients/discharge/graph${query}`).then(res => res);
}

/**
 * GET request to return client engaged data
 * @param {*} query team to filter by
 * @returns Client engaged data in format needed for Chartjs
 */
const clientGroupEngaged = function (query) {
    return axiosInstance.get(`/clients/group-hours-engaged/graph${query}`).then(res => res);
}

/**
 * GET request to return individual client engaged data
 * @param {*} query 
 * @returns 
 */
const clientIndividualEngagement = function (query) {
    return axiosInstance.get(`/clients/individual-hours-engaged/graph${query}`).then(res => res);
}


/**
 * GET request to return client entry data
 * @param {*} query team to filter by
 * @returns Client entry data in format needed for Chartjs
 */
const clientEntry = function (query) {
    return axiosInstance.get(`/clients/entry/graph${query}`).then(res => res);
}


/**
 * GET request to return client interaction data
 * @param {*} query team to filter by
 * @returns Client interaction data in format needed for Chartjs
 */
const clientInteraction = function (query) {
    return axiosInstance.get(`/clients/interaction/graph${query}`).then(res => res);
}


/**
 * GET request to return client waitlist data
 * @param {*} query team to filter by
 * @returns Client waitlist data in format needed for Chartjs
 */
const clientWaitlist = function (query) {
    return axiosInstance.get(`/clients/waitlist/graph${query}`).then(res => res);
}

/**
 * GET request to return client waitlist via 1 on 1 data
 * @param {*} query team to filter by
 * @returns Client waitlist via 1 on 1 data in format needed for Chartjs
 */
const clientIndividualWaitlist = function (query) {
    return axiosInstance.get(`/clients/individual-waitlist/graph${query}`).then(res => res);
}


/**
 * GET request to return client waitlist data
 * @param {*} query team to filter by
 * @returns Client waitlist data in format needed for Chartjs
 */
const clientEthnicity = function (query) {
    return axiosInstance.get(`/clients/ethnicity/graph${query}`).then(res => res);
}

/**
 * GET req to get client iwi data.
 * @param {*} query team to filter by
 * @returns Client iwi data in format needed for Chartjs
 */
const clientIwi = async function (query) {
    return await axiosInstance.get(`/clients/iwi/graph/${query}`).then(res => res);
}


/**
 * GET req to get interaction type data for a given staff member.
 * @returns interactions split by type for the given staff member, in pie chart data format.
 */
const clientInteractionTypes = async function (staffId) {
    return await axiosInstance.get(`/clients/interactions/types/graph/${staffId}`).then(res => res);
}

/**
 * GET req to get interaction type data for a given staff member.
 * @returns interactions split by type for the given staff member, in pie chart data format.
 */
const clientDaysSinceLastInteraction = async function (staffId) {
    return await axiosInstance.get(`/clients/interactions/time-since/graph/${staffId}`).then(res => res);
}


/**
 * GET request to return client issues data
 * @param {*} query team to filter by
 * @returns Client issues data in format needed for Chartjs
 */
const clientIssues = function (query) {
    return axiosInstance.get(`/clients/issues/graph${query}`).then(res => res);
}

/**
 * GET request to return the count of distinct clients matching the given filters
 * @param {*} query filter query string
 * @returns { count: number }
 */
const clientCount = function (query) {
    return axiosInstance.get(`/clients/count${query}`).then(res => res);
}

export default {
    clientGender,
    clientGoals,
    clientAge,
    clientIwi,
    clientReferral,
    clientDischarge,
    clientGroupEngaged,
    clientIndividualEngagement,
    clientEntry,
    clientInteraction,
    clientWaitlist,
    clientIndividualWaitlist,
    clientEthnicity,
    clientInteractionTypes,
    clientDaysSinceLastInteraction,
    clientIssues,
    clientCount,
};
